import * as React from 'react';
import px from 'prop-types';
import { LinkHint } from 'Common/components/ui';

export default function ProductManuals({ data }) {
    return (
        <div className="">
            {data.map((doc, index) => (
                <div className="d-flex" key={index}>
                    <a className="document d-flex" href={doc.Url} target="_blank" rel="noopener noreferrer">
                        <i className="far fa-file-pdf me-2" aria-hidden="true"></i>
                        <p className="doc-name">
                            {doc.Url.split('/').slice(-1)}
                            <LinkHint href={doc.Url} target="_blank" />
                        </p>
                    </a>
                </div>
            ))}
        </div>
    );
}

ProductManuals.propTypes = {
    data: px.arrayOf(px.object),
};
